import React, { Suspense } from 'react'
import { SupportContentContainer } from './styledComponents'
import { LoadingSpinner } from 'src/consumer/components/Loaders'
import { Navigate, Route, Routes } from 'react-router'
import { supportRoutes } from './routes'
import { getUserRoles } from 'src/mentor/layout/utils'

function hasAnyAllowedRole(allowedRoles = [], userRoles = []) {
  if (!Array.isArray(allowedRoles) || allowedRoles.length === 0) {
    return true
  }
  if (!Array.isArray(userRoles) || userRoles.length === 0) {
    return false
  }
  return allowedRoles.some((allowedRole) => userRoles.includes(allowedRole))
}

export default function SupportRoutesHandler({ isShowingSidebar }) {
  const userRoles = getUserRoles() || []

  return (
    <SupportContentContainer removeLeftMargins={!isShowingSidebar}>
      <Suspense fallback={<LoadingSpinner />}>
        <Routes>
          {supportRoutes?.map(({ path, fullPath, name, Element, exact, allowedRoles, ...props }, idx) => {
            const canAccessRoute = hasAnyAllowedRole(allowedRoles, userRoles)
            return (
              Element &&
              (path === '' ? (
                <Route
                  key={idx}
                  index
                  name={name}
                  element={canAccessRoute ? <Element {...props} /> : <Navigate to="/support-home" replace />}
                />
              ) : (
                <Route
                  key={idx}
                  path={path}
                  name={name}
                  element={canAccessRoute ? <Element {...props} /> : <Navigate to="/support-home" replace />}
                />
              ))
            )
          })}
        </Routes>
      </Suspense>
    </SupportContentContainer>
  )
}
